export interface PoderesOption {
  value: string;
  label: string;
}

export const PoderesOptions: PoderesOption[] = [
  {
    value: 'E',
    label: 'Executivo',
  },
  {
    value: 'N',
    label: 'Não se aplica',
  },
  {
    value: 'J',
    label: 'Judiciário',
  },
  {
    value: 'L',
    label: 'Legislativo',
  },
];
